// extracted by mini-css-extract-plugin
module.exports = {"root":"src-reactapp-App-ModalContext-CustomEmbedModal---root"};